import { JobAppSectionResponseSectionType } from "modules/api-docs";
import { PublicJobAppQuery } from "modules/graphql.types";

/**
 * Utility type to ease GraphQL operation type assignability to these functions' inputs.
 *
 * **ATTENTION**: Don't use this outside its directory.
 */
export type SelfApplyOnlyNullish<T> = T | null | undefined;

/**
 * Generic job section type that GraphQL operation type will be assignable to.
 *
 * **ATTENTION**: Don't use this outside its directory.
 */
export type SelfApplyOnlyNullishJobSection = SelfApplyOnlyNullish<{
  jobSectionType?: SelfApplyOnlyNullish<string>;
  isRequired?: SelfApplyOnlyNullish<boolean>;
}>;

// TODO: Type to work with _not_ explicitly connected to GraphQL operation type?
/**
 * **ATTENTION**: Don't use this outside its directory.
 */
export type SelfApplyOnlyNullishExistingJobApp =
  PublicJobAppQuery["publicCandidateJobApp"];

/**
 * Necessary condition for a job app section to be required.
 *
 * **ATTENTION**: Don't use this outside its directory.
 */
export function selfApplyOnlyBaseIsSectionRequired(
  /**
   * The sections of the job app defined by the job schema
   */
  jobSections: SelfApplyOnlyNullishJobSection[],
  /**
   * The relevant job app section type
   */
  sectionType: JobAppSectionResponseSectionType,
) {
  return !!jobSections?.some(
    (x) => x?.jobSectionType === sectionType && x.isRequired === true,
  );
}

/**
 * Generic type used for parsing job app sections and centralizing documentation of props. Shouldn't be used outside the context of these functions. Feel free to deviate from/discard this if necessary.
 *
 * **ATTENTION**: Don't use this outside its directory.
 */
export type SelfApplyOnlyBaseJobAppSectionFieldSetArgs = {
  /**
   * The sections of the job app defined by the job schema
   */
  jobSections: SelfApplyOnlyNullishJobSection[];
  /**
   * If present, will be used to populate the `FieldSet`'s initial values. Generally, when this is updated, the `FieldSet` will reset.
   */
  existingJobApp: SelfApplyOnlyNullishExistingJobApp;
};
